/**
 * AFF Portal - Main Application Component
 * Centralized application entry point with proper structure
 */

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { NotificationProvider } from './components/common/NotificationSystem';
import ErrorBoundary from './components/common/ErrorBoundary';
import AppRoutes from './routes/AppRoutes';
import './App.css';
import './styles/design-system.css';

function App() {
  return (
    <ErrorBoundary>
      <NotificationProvider>
        <Router>
          <AppRoutes />
        </Router>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;
